/* eslint-disable no-console */
import * as api from './account-api';
import { launchLoginModal } from './login';

const getPhotoAccountIdFromWidenId = (url, assets) => {
  const item = assets.find(asset => asset['photo-url'] === url);
  if (item !== undefined) {
    return item['photo-id'];
  }
  return null;
};

const saveItemToAccount = (type, options, callback) => {
  // console.log({ type, options, callback });
  if (window.isAuthenticated) {
    switch (type) {
      case 'location':
        api.addDealer(options, callback);
        break;
      case 'photo':
        api.addPhoto(options, callback);
        break;
      case 'swatch':
        api.addSwatch(options, callback);
        break;
      case 'visualization':
        api.addVisualization(options, callback);
        break;
      default:
        break;
    }
  } else {
    launchLoginModal({
      type,
      callbacks: {
        onLoginSuccess: () => {
          switch (type) {
            case 'location':
              api.addDealer(options, callback);
              break;
            case 'photo':
              api.addPhoto(options, callback);
              break;
            case 'swatch':
              api.addSwatch(options, callback);
              break;
            case 'visualization':
              api.addVisualization(options, callback);
              break;
            default:
              break;
          }
        },
        onLoginFail: () => {
          // console.log('storage-actions.js, onLoginFail');
          // Fix for not having to have FQ check for success param
          if (callback && type !== 'visualization') {
            callback({
              success: false,
            });
          }
        },
      },
    });
  }
};

const removeItemFromAccount = (type, id, callback) => {
  api.removeItemByType(type, id, callback);
};

const getItemsFromAccount = (type, callback) => {
  api.getItemsByType(type, callback);
};

export {
  getPhotoAccountIdFromWidenId,
  getItemsFromAccount,
  removeItemFromAccount,
  saveItemToAccount,
};
/* eslint-enable no-console */
